import useGlobalStore from '@/store/useGlobalStore'
import type { CartItemType } from '@/store/types/cart'
import T from '@/components/Helpers/Translate'
import type { HydraErrorType } from '@/lib/services/Hydra/_hydraError'
import { useFocusMode } from '@/lib/hooks/helpers/useFocusMode'
import CartSheetRecommendedProducts from '../CartSheetRecommendedProducts'
import CartSheetProductItem from '../CartSheetProductItem'
import CartSheetPromoItems from '../CartSheetPromoItems'

type Props = {
  isLoadingOrderCalculation: boolean
  orderCalculationError: HydraErrorType | null
}

const CartSheetContent = ({
  isLoadingOrderCalculation,
  orderCalculationError,
}: Props) => {
  const { cart } = useGlobalStore()
  const cartItems = [...cart.otp, ...cart.subscribe]
  const { isFocusMode, isLoadingIsFocusMode } = useFocusMode()

  const renderProducts = cartItems
    .sort((a, b) => (a.index || 0) - (b.index || 0))
    .map((order: CartItemType) => (
      <CartSheetProductItem key={order.product.pricing?.sku} cartItem={order} />
    ))

  if (cartItems.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <p className="text-center">
          <T>your_cart_is_empty</T>
        </p>
      </div>
    )
  }

  return (
    <div className="flex max-h-full min-w-full flex-1 flex-col overflow-auto">
      <div className="flex-1">
        {renderProducts}
        <div className="mt-3">
          <CartSheetPromoItems
            isLoadingOrderCalculation={isLoadingOrderCalculation}
            orderCalculationError={orderCalculationError}
          />
        </div>
      </div>

      {/* Don't show recommended products in focus mode or if loading focus mode */}
      {!isFocusMode && !isLoadingIsFocusMode && (
        <CartSheetRecommendedProducts />
      )}
    </div>
  )
}

export default CartSheetContent
